import { client } from './client';
import { FieldMetadata, OperatorInfo, MetadataContextType, SimpleExpression } from '../models/expression';

export interface ExpressionTestResult {
  isValid: boolean;
  isSimpleExpression: boolean;
  parsedExpressionString: string | null;
  simpleExpression: SimpleExpression | null;
  expressionString: string | null;
  errorMessage: string | null;
}

export const getFieldMetadata = async (contextType: MetadataContextType): Promise<FieldMetadata[]> => {
  const { data } = await client.get<FieldMetadata[]>(`/expressions/field-metadata/${contextType}`);
  return data;
};

/** Converts a structured expression to its backend string representation. */
export const convertToString = async (expression: SimpleExpression): Promise<string> => {
  const { data } = await client.post<string>('/expressions/convert-to-string', expression);
  return data;
};

/** Parses/validates an expression string, returning its structured form when valid. */
export const testExpression = async (expression: string): Promise<ExpressionTestResult> => {
  const { data } = await client.post<ExpressionTestResult>('/expressions/test', JSON.stringify(expression), {
    headers: { 'Content-Type': 'application/json' },
  });
  return data;
};

export const getOperators = async (): Promise<OperatorInfo[]> => {
  const { data } = await client.get<OperatorInfo[]>('/expressions/operators');
  return data;
};

export const getTokenFields = async (): Promise<FieldMetadata[]> => {
  const { data } = await client.get<FieldMetadata[]>('/expressions/token-fields');
  return data;
};

